import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ContainerJob, MarginContainer } from '@orientaction/commons';
import { JobLayout, TableAnnonce } from '@orientaction/components';
import { useJobContentAsAdmin } from '@orientaction/hooks';
import { getFromLS } from '@orientaction/utils';
import dateFormat from 'dateformat';
import { debounce } from 'lodash';
import { MouseEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { JobTableType, JobType } from 'src/Type/type';
import { ReactComponent as Search } from '../../../Asset/svg/search.svg';
import { apiServiceNative } from '../../../utils/fetchNative';
import { useStyles } from './style';

const Job = () => {
  const { push } = useHistory();
  const classes = useStyles();
  const { verify, getConsultantId } = useJobContentAsAdmin();

  const [dataAnnonces, setDataAnnonces] = useState<Array<JobTableType>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [seekValue, setSeekValue] = useState<string>('');
  const [pagination, setPagination] = useState<any>(null);
  const PAGE_SIZE = 10;

  useEffect(() => {
    verify();
    fetchJobConsultant(seekValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateValue = debounce(async event => {
    setLoading(true);
    try {
      const { name, value } = event.target;
      setSeekValue(value);
      await functionForFetching(value);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  }, 1000);

  const handleChange = (e: any) => {
    updateValue(e);
  };

  const onKeyDown = (event: any) => {
    updateValue(event);
  };

  const functionForFetching = async (keyword: string, page = 1) => {
    const seekResp = await apiServiceNative.get(
      `/api/jobs/consultant/${getConsultantId()}?query=${keyword}&page=${page}&pageSize=${PAGE_SIZE}`
    );
    if (seekResp && seekResp.data) {
      setDataAnnonces(transformNeededData(seekResp.data));
      setPagination(seekResp.pagination);
    }
  };

  const fetchJobConsultant = async (keyword: string, page = 1) => {
    try {
      setLoading(true);
      await functionForFetching(keyword, page);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const transformNeededData = (originalData: Array<JobType>) => {
    return originalData.map((elem: JobType) => {
      return {
        title: elem.title,
        adress: elem.addressCity,
        date: elem.publishedAt ? dateFormat(elem.publishedAt, 'dd/mm/yyyy à HH:MM:ss') : '',
        status: elem.publishedAt ? 'Publié' : 'En brouillon',
        candidats: elem.candidatures.length,
        id: elem.id,
      };
    });
  };
  const handleChangePagination = (event: MouseEvent<HTMLButtonElement>, newpage: number) => {
    fetchJobConsultant(seekValue, newpage + 1);
  };

  return (
    <JobLayout isaddBackground={true}>
      <ContainerJob>
        <MarginContainer big={true}>
          <Grid
            container={true}
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginBottom: '20px' }}>
            <Grid item={true}>
              <Typography variant="h2" style={{ textTransform: 'none' }}>
                Vos annonces
              </Typography>
            </Grid>
            <Grid item={true} style={{ display: 'flex' }} alignItems="center">
              <OutlinedInput
                placeholder="Rechercher"
                type="search"
                className={classes.inputSearch}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                id="outlined-adornment-amount"
                startAdornment={<Search style={{ marginRight: 10 }} />}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.btnPrimarySeek}
                onClick={() => push('/admin/emploi/annonces/new')}>
                Créer une annonce
              </Button>
            </Grid>
          </Grid>
          <span className={classes.separator} />
          <div>
            {loading && <CircularProgress className={classes.loader} />}
            {!loading && dataAnnonces && dataAnnonces?.length > 0 && (
              <TableAnnonce
                annonces={dataAnnonces}
                onReload={() => fetchJobConsultant(seekValue)}
                pagination={pagination}
                handleChangePagination={handleChangePagination}
              />
            )}
            {!loading && dataAnnonces?.length === 0 && (
              <Typography className={classes.textNoResult}>Aucun résultat</Typography>
            )}
          </div>
        </MarginContainer>
      </ContainerJob>
    </JobLayout>
  );
};

export default Job;
